// extracted by mini-css-extract-plugin
export var star = "starfield-module--star--Qw9Qx";
export var starField = "starfield-module--starField--dgMPT";